import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const footer = css`
  position: sticky;
  inset-block-end: 0;
  padding: ${spacing(1)};
  background-color: ${cssTheme.default.day.background};
  border-radius: ${spacing(3, 3, 0, 0)};
  filter: drop-shadow(${cssTheme.shadows.topNormal});
`
export const agreement = css`
  &::before {
    border-top: 0 !important;
  }
`

export const notificationsAgreement = css`
  padding-block: ${spacing(1)};
  &::before {
    border-top: 0 !important;
  }
`
